<template>
  <span
    class="copy-wrapper"
    @click="copyToClipboard"
  >
    <slot />
    <q-icon
      v-if="withIcon && copy"
      name="content_copy"
      color="primary"
      size="16px"
    />
    <input
      :id="`copy-${id}`"
      :value="copy"
      class="clipboard-copy-input"
    >
  </span>
</template>

<script>
export default {
  name: 'SdCopyToClipboard',
  props: {
    copy: {
      type: String,
    },
    withIcon: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      id: Math.floor(Math.random() * 10000),
    };
  },
  methods: {
    copyToClipboard() {
      const copyText = document.getElementById(`copy-${this.id}`);
      copyText.focus();
      copyText.select();
      copyText.setSelectionRange(0, 99999); /* For mobile devices */
      document.execCommand('copy');
      copyText.blur();
      this.uiNotify(`${this.copy} copied to clipboard`);
    },
  },
};
</script>

<style scoped>
.copy-wrapper {
    cursor: pointer;
}

.clipboard-copy-input {
    width: 0.75rem;
    height: 2px;
    border: none;
    text-indent: 2rem;
    background: transparent;
}
</style>
